var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBankingImg2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 2917.91 2850.57",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{isolation:isolate;}.cls-2{fill:url(#linear-gradient);}.cls-3{fill:url(#linear-gradient-2);}.cls-4{fill:url(#linear-gradient-3);}.cls-15,.cls-5,.cls-56,.cls-6{fill:#fff;}.cls-6{opacity:0.78;}.cls-7{fill:url(#linear-gradient-4);}.cls-8{fill:url(#linear-gradient-5);}.cls-9{fill:url(#linear-gradient-6);}.cls-10{fill:url(#linear-gradient-7);}.cls-11{fill:url(#linear-gradient-8);}.cls-12{fill:url(#linear-gradient-9);}.cls-13{fill:url(#linear-gradient-10);}.cls-14{fill:#bdd0fb;}.cls-15{mix-blend-mode:soft-light;}.cls-16{fill:#91b3fa;}.cls-17{fill:#18174a;}.cls-18{fill:#7d97f4;}.cls-19{fill:url(#linear-gradient-11);}.cls-20{fill:url(#linear-gradient-12);}.cls-21{fill:url(#linear-gradient-13);}.cls-22{fill:url(#linear-gradient-14);}.cls-23{fill:url(#linear-gradient-15);}.cls-24{fill:url(#linear-gradient-16);}.cls-25{fill:url(#linear-gradient-17);}.cls-26{fill:url(#linear-gradient-18);}.cls-27{fill:url(#linear-gradient-19);}.cls-28{fill:url(#linear-gradient-20);}.cls-29{fill:url(#linear-gradient-21);}.cls-30{fill:url(#linear-gradient-22);}.cls-31{fill:url(#linear-gradient-23);}.cls-32{fill:url(#linear-gradient-24);}.cls-33{fill:url(#linear-gradient-25);}.cls-34{fill:url(#linear-gradient-26);}.cls-35{fill:url(#linear-gradient-27);}.cls-36{fill:url(#linear-gradient-28);}.cls-37{fill:url(#linear-gradient-29);}.cls-38{fill:url(#linear-gradient-30);}.cls-39{fill:url(#linear-gradient-31);}.cls-40{fill:url(#linear-gradient-32);}.cls-41{fill:url(#linear-gradient-33);}.cls-42{fill:url(#linear-gradient-34);}.cls-43{fill:url(#linear-gradient-35);}.cls-44{fill:url(#linear-gradient-36);}.cls-45{fill:url(#linear-gradient-37);}.cls-46{fill:url(#linear-gradient-38);}.cls-47{fill:url(#linear-gradient-39);}.cls-48{fill:url(#linear-gradient-40);}.cls-49{fill:url(#linear-gradient-41);}.cls-50{fill:url(#linear-gradient-42);}.cls-51{fill:url(#linear-gradient-43);}.cls-52{opacity:0.54;}.cls-53{fill:url(#linear-gradient-44);}.cls-54{fill:#2b69b3;}.cls-55{fill:url(#linear-gradient-45);}.cls-56,.cls-57{opacity:0.8;}.cls-58{fill:url(#linear-gradient-46);}.cls-59{fill:url(#linear-gradient-47);}.cls-60{fill:url(#linear-gradient-48);}.cls-61{fill:url(#linear-gradient-49);}.cls-62{fill:url(#linear-gradient-50);}.cls-63{fill:url(#linear-gradient-51);}.cls-64{fill:url(#linear-gradient-52);}.cls-65{fill:url(#linear-gradient-53);}.cls-66{fill:url(#linear-gradient-54);}.cls-67{fill:url(#linear-gradient-55);}.cls-68{fill:url(#linear-gradient-56);}.cls-69{fill:url(#linear-gradient-57);}.cls-70{fill:url(#linear-gradient-58);}.cls-71{fill:url(#linear-gradient-59);}.cls-72{fill:url(#linear-gradient-60);}.cls-73{fill:url(#linear-gradient-61);}.cls-74{fill:url(#linear-gradient-62);}.cls-75{fill:url(#linear-gradient-63);}.cls-76{fill:url(#linear-gradient-64);}.cls-77{fill:url(#linear-gradient-65);}.cls-78{fill:url(#linear-gradient-66);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 3015.74,
    y1: 3255.9,
    x2: 958.15,
    y2: 1035.01,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#dae3fe"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e9effd"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 970.4,
    y1: 440.81,
    x2: 1153.94,
    y2: 227.78,
    gradientTransform: "matrix(0.63, 0.78, -0.78, 0.63, 702.65, -611.01)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e1473d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e9605a"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 1257.65,
    y1: 72.41,
    x2: 714.93,
    y2: 892.29,
    gradientTransform: "matrix(0.63, 0.78, -0.78, 0.63, 702.65, -611.01)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff928e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fe7062"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 932.87,
    y1: 1798.06,
    x2: 971.54,
    y2: 1532.64,
    gradientTransform: "matrix(0.99, 0.11, -0.11, 0.99, 126.15, 83.22)",
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 1350.19,
    y1: 477.41,
    x2: 1669.69,
    y2: 106.56,
    gradientTransform: "matrix(0.63, 0.78, -0.78, 0.63, 810.26, -1004.67)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 1850.23,
    y1: -163.92,
    x2: 905.45,
    y2: 1263.36,
    gradientTransform: "matrix(0.63, 0.78, -0.78, 0.63, 810.26, -1004.67)",
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: 1153.67,
    y1: 1536.62,
    x2: 1315.39,
    y2: 1100.69,
    gradientTransform: "matrix(0.99, 0.11, -0.11, 0.99, 126.15, 83.22)",
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: 1918.35,
    y1: 557.04,
    x2: 2159.23,
    y2: 277.44,
    gradientTransform: "matrix(0.63, 0.78, -0.78, 0.63, 1105.93, -1268.35)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9",
    x1: 2295.35,
    y1: 73.52,
    x2: 1583.06,
    y2: 1149.59,
    gradientTransform: "matrix(0.63, 0.78, -0.78, 0.63, 1105.93, -1268.35)",
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-10",
    x1: 2336.92,
    y1: 299.9,
    x2: 2192.78,
    y2: 804.38,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-11",
    x1: 1470.83,
    y1: 913.55,
    x2: 2520.6,
    y2: 913.55,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-12",
    x1: 1518.55,
    y1: 1259.41,
    x2: 1540.46,
    y2: 1259.41,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-13",
    x1: 1551.42,
    y1: 1259.41,
    x2: 1573.33,
    y2: 1259.41,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-14",
    x1: 1584.29,
    y1: 1259.41,
    x2: 1606.2,
    y2: 1259.41,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-15",
    x1: 1494.44,
    y1: 1043.56,
    x2: 1630.31,
    y2: 1043.56,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-16",
    x1: 1495.54,
    y1: 1480.74,
    x2: 1631.4,
    y2: 1480.74,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-17",
    x1: 1691.66,
    y1: 1259.41,
    x2: 1713.58,
    y2: 1259.41,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-18",
    x1: 1724.53,
    y1: 1259.41,
    x2: 1746.45,
    y2: 1259.41,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-19",
    x1: 1757.4,
    y1: 1259.41,
    x2: 1779.32,
    y2: 1259.41,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-20",
    x1: 1667.56,
    y1: 1043.56,
    x2: 1803.42,
    y2: 1043.56,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-21",
    x1: 1668.66,
    y1: 1480.74,
    x2: 1804.52,
    y2: 1480.74,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-22",
    x1: 1864.78,
    y1: 1259.41,
    x2: 1886.69,
    y2: 1259.41,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-23",
    x1: 1897.65,
    y1: 1259.41,
    x2: 1919.56,
    y2: 1259.41,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-24",
    x1: 1930.52,
    y1: 1259.41,
    x2: 1952.43,
    y2: 1259.41,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-25",
    x1: 1840.68,
    y1: 1043.56,
    x2: 1976.54,
    y2: 1043.56,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-26",
    x1: 1841.77,
    y1: 1480.74,
    x2: 1977.63,
    y2: 1480.74,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-27",
    x1: 2037.9,
    y1: 1259.41,
    x2: 2059.81,
    y2: 1259.41,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-28",
    x1: 2070.77,
    y1: 1259.41,
    x2: 2092.68,
    y2: 1259.41,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-29",
    x1: 2103.64,
    y1: 1259.41,
    x2: 2125.55,
    y2: 1259.41,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-30",
    x1: 2013.79,
    y1: 1043.56,
    x2: 2149.65,
    y2: 1043.56,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-31",
    x1: 2014.89,
    y1: 1480.74,
    x2: 2150.75,
    y2: 1480.74,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-32",
    x1: 2211.01,
    y1: 1259.41,
    x2: 2232.93,
    y2: 1259.41,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-33",
    x1: 2243.88,
    y1: 1259.41,
    x2: 2265.8,
    y2: 1259.41,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-34",
    x1: 2276.75,
    y1: 1259.41,
    x2: 2298.67,
    y2: 1259.41,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-35",
    x1: 2186.91,
    y1: 1043.56,
    x2: 2322.77,
    y2: 1043.56,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-36",
    x1: 2188,
    y1: 1480.74,
    x2: 2323.87,
    y2: 1480.74,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-37",
    x1: 2384.13,
    y1: 1259.41,
    x2: 2406.04,
    y2: 1259.41,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-38",
    x1: 2417,
    y1: 1259.41,
    x2: 2438.91,
    y2: 1259.41,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-39",
    x1: 2449.87,
    y1: 1259.41,
    x2: 2471.78,
    y2: 1259.41,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-40",
    x1: 2360.02,
    y1: 1043.56,
    x2: 2495.89,
    y2: 1043.56,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-41",
    x1: 2361.12,
    y1: 1480.74,
    x2: 2496.98,
    y2: 1480.74,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-42",
    x1: 1459.32,
    y1: 1516.9,
    x2: 2538.97,
    y2: 1516.9,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-43",
    x1: 1406.21,
    y1: 1570.49,
    x2: 2585.21,
    y2: 1570.49,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-44",
    x1: 1052.59,
    y1: 1027.93,
    x2: 1207.27,
    y2: 425.02,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#4f52ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4042e2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-45",
    x1: 562.99,
    y1: -82.36,
    x2: 268.98,
    y2: 29.52,
    gradientTransform: "translate(918.88 339.38) rotate(90)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#febbba"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff928e"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-46",
    x1: -3188.9,
    y1: 2516.19,
    x2: -2987.47,
    y2: 2516.19,
    gradientTransform: "matrix(-1, 0, 0, 1, -2428.14, 0)",
    xlinkHref: "#linear-gradient-45"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-47",
    x1: -3421.21,
    y1: 2528.63,
    x2: -3000.35,
    y2: 2528.63,
    gradientTransform: "matrix(-1, 0, 0, 1, -2428.14, 0)",
    xlinkHref: "#linear-gradient-45"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-48",
    x1: 40.44,
    y1: 2211,
    x2: 546.68,
    y2: 2003.58,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-49",
    x1: -3692.88,
    y1: 935.62,
    x2: -3714.14,
    y2: 799.2,
    gradientTransform: "matrix(-0.96, -0.26, -0.26, 0.96, -2803.33, 47.92)",
    xlinkHref: "#linear-gradient-45"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-50",
    x1: -3758.43,
    y1: 704.36,
    x2: -3627.16,
    y2: 872.37,
    gradientTransform: "matrix(-0.96, -0.26, -0.26, 0.96, -2803.33, 47.92)",
    xlinkHref: "#linear-gradient-45"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-51",
    x1: -2825.93,
    y1: 2182.79,
    x2: -2426.64,
    y2: 2182.79,
    gradientTransform: "matrix(-1, 0, 0, 1, -2428.14, 0)",
    xlinkHref: "#linear-gradient-45"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-52",
    x1: 850.71,
    y1: 2078.17,
    x2: 894.7,
    y2: 2078.17,
    xlinkHref: "#linear-gradient-44"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-53",
    x1: -3726.74,
    y1: 679.6,
    x2: -3595.46,
    y2: 847.6,
    gradientTransform: "matrix(-0.96, -0.26, -0.26, 0.96, -2803.33, 47.92)",
    xlinkHref: "#linear-gradient-45"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-54",
    x1: -6681.31,
    y1: 2587.37,
    x2: -6506.27,
    y2: 2587.37,
    gradientTransform: "matrix(-1, 0, 0, 1, -4263.97, 0)",
    xlinkHref: "#linear-gradient-44"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-55",
    x1: -6665.15,
    y1: 2505.16,
    x2: -6615.85,
    y2: 2505.16,
    gradientTransform: "matrix(-1, 0, 0, 1, -4263.97, 0)",
    xlinkHref: "#linear-gradient-45"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-56",
    x1: -6942.09,
    y1: 2479.45,
    x2: -6883.16,
    y2: 2479.45,
    gradientTransform: "matrix(-1, 0, 0, 1, -4263.97, 0)",
    xlinkHref: "#linear-gradient-45"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-57",
    x1: 2786.89,
    y1: 1269.55,
    x2: 2354.48,
    y2: 1923.43,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#09005d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1a0f91"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-58",
    x1: -6131.56,
    y1: 1238.2,
    x2: -6364.95,
    y2: 1541.83,
    gradientTransform: "matrix(-1, 0, 0, 1, -4263.97, 0)",
    xlinkHref: "#linear-gradient-45"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-59",
    x1: 3351.24,
    y1: 1225.47,
    x2: 2317.69,
    y2: 1548.9,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-60",
    x1: 2084.73,
    y1: 1649.41,
    x2: 2288.33,
    y2: 1621.76,
    gradientTransform: "matrix(0.77, 0.13, -0.16, 0.99, 907.95, -487.89)",
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-61",
    x1: -6651.78,
    y1: 1434.44,
    x2: -6626.24,
    y2: 1300.39,
    gradientTransform: "matrix(-1, 0, 0, 1, -4263.97, 0)",
    xlinkHref: "#linear-gradient-45"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-62",
    x1: -6582.69,
    y1: 1188.51,
    x2: -6728.37,
    y2: 1299.98,
    gradientTransform: "matrix(-1, 0, 0, 1, -4263.97, 0)",
    xlinkHref: "#linear-gradient-45"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-63",
    x1: -6600.76,
    y1: 1164.89,
    x2: -6746.44,
    y2: 1276.36,
    gradientTransform: "matrix(-1, 0, 0, 1, -4263.97, 0)",
    xlinkHref: "#linear-gradient-45"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-64",
    x1: 1804,
    y1: 1213.88,
    x2: 1857.79,
    y2: 1213.88,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-65",
    x1: -5586.47,
    y1: 8146.65,
    x2: -5523.19,
    y2: 8522.81,
    gradientTransform: "matrix(-1, 0, 0, 1, -4263.97, 0)",
    xlinkHref: "#linear-gradient-45"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-66",
    x1: 2344.27,
    y1: 1747.75,
    x2: 2440.36,
    y2: 1583.69,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-45"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Illustration"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M2729,1990.29c-282.73,660.85-1029,944.69-1613.78,896.3-159.66-13.22-480.9-39.8-731.72-277C-98.2,2154.07-24,1201.9,437.11,641.32c59.38-72.2,470.42-555.87,1110.94-549.4,469,4.74,798.11,269.65,838.14,302.65,50.56,41.69,162.07,140.76,262.58,297.93C2884.92,1061.8,2905.68,1577.33,2729,1990.29Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 1252.4,
    cy: 432,
    r: 136.83,
    transform: "translate(61.35 1012.11) rotate(-45)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 1252.4,
    cy: 432,
    r: 132.28,
    transform: "translate(61.35 1012.11) rotate(-45)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M1150,367.2a1.78,1.78,0,0,1-1-.28,1.76,1.76,0,0,1-.51-2.43,124.09,124.09,0,0,1,139.42-51.17,1.77,1.77,0,0,1,1.19,2.19,1.75,1.75,0,0,1-2.19,1.18,121.36,121.36,0,0,0-21.37-4.32,119.86,119.86,0,0,0-114.11,54A1.74,1.74,0,0,1,1150,367.2Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-6",
    cx: 1254.95,
    cy: 435.18,
    r: 111.96,
    transform: "translate(59.85 1014.85) rotate(-45)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M1234.92,516.71l1.33-12.1c-12.56-1.9-24.72-6.25-33.16-11.11a7.06,7.06,0,0,1-3-8.7l4.32-10.94a7.1,7.1,0,0,1,10.09-3.56,82.59,82.59,0,0,0,30.64,10.05c12.16,1.34,21.68-1.78,22.61-10.23.84-7.62-5.67-12.93-22.07-19.32-23.38-9.25-39.53-21.66-37.19-42.89,2.11-19.16,17.73-32.25,42.47-33.48l1.34-12.11a7.09,7.09,0,0,1,7.83-6.28l7.11.78a7.1,7.1,0,0,1,6.28,7.84l-1.2,10.87a90.32,90.32,0,0,1,26.4,7.8,7.05,7.05,0,0,1,3.45,8.95l-4,10.12a7.08,7.08,0,0,1-9.81,3.73,74,74,0,0,0-25.88-7.7c-14.42-1.59-19.2,3.93-19.79,9.29-.73,6.59,7.43,12.08,25.54,19.91,25.91,11,35.81,23.34,33.61,43.33-2,18.34-17.44,33.32-44.26,34.54l-1.5,13.55a7.09,7.09,0,0,1-7.83,6.28l-7.11-.79A7.09,7.09,0,0,1,1234.92,516.71Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-8",
    cx: 1781.39,
    cy: 365.07,
    r: 238.2,
    transform: "translate(263.62 1366.56) rotate(-45)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-9",
    cx: 1781.4,
    cy: 365.07,
    r: 230.28,
    transform: "translate(263.62 1366.56) rotate(-45)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M1603.12,251a1.77,1.77,0,0,1-1.48-2.72A213.45,213.45,0,0,1,1804.85,152a216,216,0,0,1,38.05,7.69,1.76,1.76,0,1,1-1,3.37,212.06,212.06,0,0,0-37.43-7.56,209.94,209.94,0,0,0-199.88,94.64A1.75,1.75,0,0,1,1603.12,251Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-6",
    cx: 1785.83,
    cy: 370.6,
    r: 194.9,
    transform: "translate(261 1371.32) rotate(-45)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M1751,512.53l2.33-21.08c-21.88-3.29-43-10.87-57.73-19.33A12.26,12.26,0,0,1,1690.4,457l7.52-19.05a12.36,12.36,0,0,1,17.57-6.2c14.6,8.1,33,15.26,53.34,17.51,21.16,2.33,37.73-3.11,39.35-17.82,1.46-13.27-9.86-22.5-38.41-33.63-40.7-16.1-68.82-37.71-64.75-74.66,3.67-33.36,30.87-56.14,73.94-58.29l2.32-21.08a12.35,12.35,0,0,1,13.64-10.93l12.38,1.36a12.36,12.36,0,0,1,10.93,13.64l-2.08,18.92c20.24,3.05,34.65,8.16,45.95,13.58a12.3,12.3,0,0,1,6,15.59l-6.93,17.62a12.32,12.32,0,0,1-17.07,6.49,128.77,128.77,0,0,0-45.06-13.41c-25.11-2.77-33.43,6.85-34.45,16.17-1.27,11.48,12.93,21,44.46,34.67,45.09,19.12,62.33,40.62,58.5,75.42-3.52,31.92-30.35,58-77,60.13l-2.6,23.59a12.35,12.35,0,0,1-13.63,10.93l-12.39-1.37A12.36,12.36,0,0,1,1751,512.53Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-11",
    cx: 2247.53,
    cy: 590.13,
    r: 179.59,
    transform: "translate(241 1762.09) rotate(-45)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-12",
    cx: 2247.53,
    cy: 590.13,
    r: 173.62,
    transform: "translate(241 1762.09) rotate(-45)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M2113.12,504.54a1.79,1.79,0,0,1-1-.29,1.76,1.76,0,0,1-.51-2.43,161.38,161.38,0,0,1,153.61-72.74,164.28,164.28,0,0,1,28.77,5.81,1.76,1.76,0,1,1-1,3.37,160,160,0,0,0-28.14-5.68,157.84,157.84,0,0,0-150.28,71.16A1.78,1.78,0,0,1,2113.12,504.54Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-6",
    cx: 2250.88,
    cy: 594.31,
    r: 146.94,
    transform: "translate(239.03 1765.68) rotate(-45)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M2224.59,701.31l1.75-15.89c-16.49-2.49-32.45-8.2-43.53-14.58a9.24,9.24,0,0,1-3.88-11.41l5.67-14.36a9.31,9.31,0,0,1,13.24-4.68,108.18,108.18,0,0,0,40.21,13.2c16,1.76,28.45-2.34,29.68-13.43,1.1-10-7.44-17-29-25.36-30.69-12.13-51.89-28.43-48.82-56.28,2.77-25.15,23.27-42.33,55.75-43.95l1.75-15.9a9.32,9.32,0,0,1,10.28-8.24l9.33,1a9.31,9.31,0,0,1,8.24,10.28L2273.73,516c15.26,2.3,26.13,6.15,34.64,10.24a9.27,9.27,0,0,1,4.54,11.75l-5.22,13.28a9.31,9.31,0,0,1-12.88,4.9,97,97,0,0,0-34-10.11c-18.93-2.09-25.2,5.16-26,12.19-1,8.66,9.75,15.85,33.53,26.14,34,14.41,47,30.63,44.1,56.86-2.65,24.07-22.88,43.74-58.09,45.33l-2,17.79a9.31,9.31,0,0,1-10.27,8.24l-9.34-1A9.31,9.31,0,0,1,2224.59,701.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M31.33,127.19C28.62,115.67,44.82,108,54.74,116.06c100.74,81.69,342.78,326.3,282.46,753.79C261.52,1406.19,390.9,1601.9,552,1721.28c0,0-221.18-56.14-360.34-254.73C-150,979,79.43,332,31.33,127.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M108,294.71c12.6,59.71,23.83,119.6,32.51,179.76q13.58,90.16,20.72,180.85c4.47,60.43,7.63,120.92,7.81,181.44.5,60.51-2,121-4.79,181.68-2.38,60.68-5.17,121.8-.73,183.35s17.3,123.38,43,181.47c6.42,14.48,13.16,28.91,20.82,42.85,7.37,14.07,15.46,27.87,23.83,41.53a656.1,656.1,0,0,0,57.14,78.61c42.57,49.92,93.91,94.2,150.47,131.68,5.95,3.94,14.48,3,19-2.17s3.48-12.24-2.19-16.23l0,0c-13.46-9.45-26.78-19-39.55-29.08-6.48-4.94-12.7-10.11-19-15.19-6.1-5.27-12.43-10.34-18.33-15.77a651,651,0,0,1-66.45-68.3c-40.6-48-73.1-101.49-97.72-156.94A530,530,0,0,1,206,1288.7a584.4,584.4,0,0,1-13.74-88.58c-4.84-59.74-2.66-120.25-.78-180.94s3.09-121.72,1.48-182.69q-1-45.72-4-91.38c-.89-15.22-2.11-30.42-3.3-45.62q-2.06-22.79-4.43-45.54-9.81-91-26.1-181.29c-11.21-60.1-24.27-119.93-40-179.22a3.7,3.7,0,0,0-4.37-2.36A3.19,3.19,0,0,0,108,294.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M292.53,1341.77c-12.35,13.1-34.08,9.34-41.51-7.07-41-90.51-133.77-356.9,19.45-663.8,129.39-259.17,174.93-412,190.79-482.8,3.35-15,23.87-17,30.07-2.92C559.66,340.06,740.09,866.91,292.53,1341.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M270.09,1332.22a7.53,7.53,0,0,1-1.35.11,7,7,0,0,1-6.93-7.14c.07-4.4,8.64-444.35,172.27-812.83a7,7,0,1,1,12.85,5.71c-162.44,365.79-171,803-171.06,807.34A7,7,0,0,1,270.09,1332.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M2718,2208.79a45.86,45.86,0,0,1-45.75,45.7H198.4a45.86,45.86,0,0,1-45.75-45.7L132.07,787.15c0-25.14,29.61-74.22,83.89-70.53l2417.7-62.56A115.28,115.28,0,0,1,2752,772Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M2672.81,2164.94a43.41,43.41,0,0,1-43.28,43.28H258.06a43.41,43.41,0,0,1-43.28-43.28L195.35,874.36C197.64,796.7,265.73,768.78,307,770.43l2317.21-62.16a80.89,80.89,0,0,1,83.05,82.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M319.26,2093.34c2.48-106.66,1.55-1051.23-4.57-1132.81s120.94-96.88,316-106.06,1840.88-45.53,1883.25-49c95.26-7.73,115,134.65,105.44,443.73-7.16,232.21-19,614.73-24.48,790.65a97.09,97.09,0,0,1-96.85,94.08c-396.05,1.09-1914,5.44-2015,8.45C366.72,2145.88,318.27,2135.64,319.26,2093.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M2855.46,2362.71H63.82a62.63,62.63,0,0,1-62.45-62.45h0a62.64,62.64,0,0,1,62.45-62.46H2855.46a62.64,62.64,0,0,1,62.45,62.46h0A62.63,62.63,0,0,1,2855.46,2362.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M2506.67,1028.05H1484.76c-15.37,0-19.39-21.23-5.1-26.86l511-201.18a13.9,13.9,0,0,1,10.19,0l511,201.18C2526.06,1006.82,2522,1028.05,2506.67,1028.05Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-20",
    x: 1518.55,
    y: 1057.81,
    width: 21.91,
    height: 403.21
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-21",
    x: 1551.42,
    y: 1057.81,
    width: 21.91,
    height: 403.21
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-22",
    x: 1584.29,
    y: 1057.81,
    width: 21.91,
    height: 403.21
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-23",
    points: "1630.31 1035.89 1494.44 1035.89 1494.44 1041.79 1514.16 1051.23 1610.58 1051.23 1630.31 1041.79 1630.31 1035.89"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-24",
    points: "1631.4 1496.08 1495.54 1496.08 1495.54 1474.84 1515.26 1465.4 1611.68 1465.4 1631.4 1474.84 1631.4 1496.08"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-25",
    x: 1691.66,
    y: 1057.81,
    width: 21.91,
    height: 403.21
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-26",
    x: 1724.53,
    y: 1057.81,
    width: 21.91,
    height: 403.21
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-27",
    x: 1757.4,
    y: 1057.81,
    width: 21.91,
    height: 403.21
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-28",
    points: "1803.42 1035.89 1667.56 1035.89 1667.56 1041.79 1687.28 1051.23 1783.7 1051.23 1803.42 1041.79 1803.42 1035.89"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-29",
    points: "1804.52 1496.08 1668.65 1496.08 1668.65 1474.84 1688.38 1465.4 1784.8 1465.4 1804.52 1474.84 1804.52 1496.08"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-30",
    x: 1864.78,
    y: 1057.81,
    width: 21.91,
    height: 403.21
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-31",
    x: 1897.65,
    y: 1057.81,
    width: 21.91,
    height: 403.21
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-32",
    x: 1930.52,
    y: 1057.81,
    width: 21.91,
    height: 403.21
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-33",
    points: "1976.54 1035.89 1840.68 1035.89 1840.68 1041.79 1860.4 1051.23 1956.82 1051.23 1976.54 1041.79 1976.54 1035.89"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-34",
    points: "1977.63 1496.08 1841.77 1496.08 1841.77 1474.84 1861.49 1465.4 1957.91 1465.4 1977.63 1474.84 1977.63 1496.08"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-35",
    x: 2037.9,
    y: 1057.81,
    width: 21.91,
    height: 403.21
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-36",
    x: 2070.77,
    y: 1057.81,
    width: 21.91,
    height: 403.21
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-37",
    x: 2103.64,
    y: 1057.81,
    width: 21.91,
    height: 403.21
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-38",
    points: "2149.66 1035.89 2013.79 1035.89 2013.79 1041.79 2033.51 1051.23 2129.93 1051.23 2149.66 1041.79 2149.66 1035.89"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-39",
    points: "2150.75 1496.08 2014.89 1496.08 2014.89 1474.84 2034.61 1465.4 2131.03 1465.4 2150.75 1474.84 2150.75 1496.08"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-40",
    x: 2211.01,
    y: 1057.81,
    width: 21.91,
    height: 403.21
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-41",
    x: 2243.88,
    y: 1057.81,
    width: 21.91,
    height: 403.21
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-42",
    x: 2276.75,
    y: 1057.81,
    width: 21.91,
    height: 403.21
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-43",
    points: "2322.77 1035.89 2186.91 1035.89 2186.91 1041.79 2206.63 1051.23 2303.05 1051.23 2322.77 1041.79 2322.77 1035.89"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-44",
    points: "2323.87 1496.08 2188 1496.08 2188 1474.84 2207.73 1465.4 2304.14 1465.4 2323.87 1474.84 2323.87 1496.08"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-45",
    x: 2384.13,
    y: 1057.81,
    width: 21.91,
    height: 403.21
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-46",
    x: 2417,
    y: 1057.81,
    width: 21.91,
    height: 403.21
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-47",
    x: 2449.87,
    y: 1057.81,
    width: 21.91,
    height: 403.21
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-48",
    points: "2495.89 1035.89 2360.02 1035.89 2360.02 1041.79 2379.75 1051.23 2476.16 1051.23 2495.89 1041.79 2495.89 1035.89"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-49",
    points: "2496.98 1496.08 2361.12 1496.08 2361.12 1474.84 2380.84 1465.4 2477.26 1465.4 2496.98 1474.84 2496.98 1496.08"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-50",
    x: 1459.32,
    y: 1505.14,
    width: 1079.66,
    height: 23.53,
    rx: 2.09
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-51",
    x: 1406.21,
    y: 1540.43,
    width: 1179,
    height: 60.13,
    rx: 4.5
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-52"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M1039.75,1917.94l592.87-3.31c24.27-.13,39.35,26.33,26.86,47.14l-3,5a31.12,31.12,0,0,1-26.68,15.1h-589.9a31.12,31.12,0,0,1-31.12-31.12v-1.65A31.12,31.12,0,0,1,1039.75,1917.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M956.93,1949.75v1a31.12,31.12,0,0,1-31.12,31.12H794.2a31.13,31.13,0,0,1-30.07-23.09h0A31.12,31.12,0,0,1,794,1919.59l131.61-1A31.12,31.12,0,0,1,956.93,1949.75Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M1182.36,2029.65l450.26-3.31c24.27-.13,39.35,26.33,26.86,47.14l-3,5a31.12,31.12,0,0,1-26.68,15.1H1182.54a31.12,31.12,0,0,1-31.12-31.12v-1.65A31.11,31.11,0,0,1,1182.36,2029.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M1099.54,2061.46v1a31.12,31.12,0,0,1-31.12,31.12H936.81a31.12,31.12,0,0,1-30.06-23.08h0a31.12,31.12,0,0,1,29.84-39.16l131.61-1A31.11,31.11,0,0,1,1099.54,2061.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-53",
    d: "M1532.73,473.14,1515.24,833l-2.71,55.73a13.29,13.29,0,0,1-13.57,12.9L783,883.78a13.29,13.29,0,0,1-12.92-13.56l.59-55.78,3.72-355.82c.18-7.28,9.11-21.27,24.79-19.8l700.19-.66a33.38,33.38,0,0,1,33.38,35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-54",
    d: "M1495.31,877a12.53,12.53,0,0,1-12.92,12l-682.05-17A12.51,12.51,0,0,1,788,859.4l3.9-384.11c.17-6.79,8.66-19.84,23.6-18.47l667-.27a32.2,32.2,0,0,1,23.06,9.66,30.78,30.78,0,0,1,8.76,23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M1482.34,892.57h-.45l-76.36-1.9a1.76,1.76,0,0,1,0-3.52h0l76.36,1.91h.35c9.31,0,18.55-8.95,18.79-18.3l5.82-233.53a1.76,1.76,0,0,1,3.51.09l-5.82,233.53C1504.35,882.13,1493.58,892.57,1482.34,892.57Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-55",
    x: 856.36,
    y: 587.38,
    width: 93.78,
    height: 114.96,
    rx: 13.25,
    transform: "translate(236.07 1531.76) rotate(-88.57)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-56",
    d: "M911,663.46h-.15l-25.22-.62A5.8,5.8,0,0,1,880,656.9l.56-22.2a5.73,5.73,0,0,1,1.79-4,6,6,0,0,1,4.13-1.59l25.22.62a5.79,5.79,0,0,1,5.64,5.93h0l-.55,22.2A5.8,5.8,0,0,1,911,663.46Zm-24.67-30.88a2.21,2.21,0,0,0-1.56.63,2.26,2.26,0,0,0-.71,1.58l-.55,22.2a2.27,2.27,0,0,0,2.21,2.32l25.22.63H911a2.27,2.27,0,0,0,2.26-2.21l.55-22.2a2.25,2.25,0,0,0-2.21-2.32l-25.22-.63Zm29.24,3h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M882.2,641.55h-.05l-36.29-.9a1.76,1.76,0,0,1,0-3.52h0l36.29.91a1.76,1.76,0,0,1,0,3.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M882,650.63h0l-36.29-.91a1.76,1.76,0,0,1-1.72-1.8,1.71,1.71,0,0,1,1.81-1.71l36.29.9a1.76,1.76,0,0,1,0,3.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M960.83,643.51h0l-39.32-1a1.76,1.76,0,0,1,0-3.51h0l39.32,1a1.76,1.76,0,0,1,0,3.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M960.61,652.59h-.05l-39.32-1a1.76,1.76,0,0,1,0-3.52h0l39.32,1a1.76,1.76,0,0,1,0,3.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M890.67,632.83a1.75,1.75,0,0,1-1.71-1.4l-7-33.11a1.76,1.76,0,0,1,1.35-2.08,1.78,1.78,0,0,1,2.09,1.36l7,33.11a1.76,1.76,0,0,1-1.36,2.08A1.5,1.5,0,0,1,890.67,632.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M911.75,633.35a1.49,1.49,0,0,1-.46-.06,1.76,1.76,0,0,1-1.23-2.16l8.9-32.71a1.76,1.76,0,0,1,3.4.93l-8.91,32.71A1.75,1.75,0,0,1,911.75,633.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M881.35,694.13a1.76,1.76,0,0,1-1.7-2.21l8.62-32.72a1.76,1.76,0,0,1,3.4.9l-8.62,32.72A1.76,1.76,0,0,1,881.35,694.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M918.3,695.05a1.75,1.75,0,0,1-1.71-1.38l-7.26-33.12a1.76,1.76,0,1,1,3.43-.75L920,692.92a1.76,1.76,0,0,1-1.34,2.09A1.58,1.58,0,0,1,918.3,695.05Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-16",
    x: 882.37,
    y: 446.56,
    width: 33.28,
    height: 130.09,
    rx: 15.73,
    transform: "translate(365.16 1397.58) rotate(-88.57)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M967.19,751a15,15,0,0,1-15.39,14.64l-109.1-2.72a15,15,0,0,1-14.63-15.38v-.23a15,15,0,0,1,15.38-14.64l109.11,2.73a15,15,0,0,1,14.63,15.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M1124.45,754.9a15,15,0,0,1-15.38,14.63L1000,766.81a15,15,0,0,1-14.64-15.38v-.23a15,15,0,0,1,15.38-14.63l109.11,2.72a15,15,0,0,1,14.63,15.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M1281.72,758.82a15,15,0,0,1-15.38,14.63s-123.95-9.81-123.74-18.1v-.23A15,15,0,0,1,1158,740.49l109.1,2.72a15,15,0,0,1,14.64,15.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M1442,762.82a15,15,0,0,1-15.38,14.63l-109.1-2.72a15,15,0,0,1-14.64-15.38v-.23a15,15,0,0,1,15.38-14.63l109.11,2.72A15,15,0,0,1,1442,762.59Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-57"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-14",
    x: 942.84,
    y: 703.68,
    width: 24.2,
    height: 226.9,
    rx: 11.94,
    transform: "translate(114.25 1751.41) rotate(-88.57)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M1422.36,822.9a12,12,0,0,1-12.23,11.64l-88-2.2a11.93,11.93,0,0,1-11.63-12.23v-.33a11.93,11.93,0,0,1,12.23-11.63l88,2.19a12,12,0,0,1,11.64,12.23Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-54",
    d: "M1082.43,1536.85l-313.06,17.77a48.05,48.05,0,0,1-50.64-44.52l-26.11-363.18a48,48,0,0,1,47.92-51.48h339.17a48,48,0,0,1,48,48v345.4A48,48,0,0,1,1082.43,1536.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M779.44,1325.06c0,79.27,64.49,143.75,143.75,143.75s143.75-64.48,143.75-143.75a143.44,143.44,0,0,0-51.22-109.88v-.4l-.49,0a143.42,143.42,0,0,0-184.08,0h-.47v.39A143.48,143.48,0,0,0,779.44,1325.06Zm6.87,2.13.93,0,31.88.2a183.1,183.1,0,0,0,6.25,44.78l-30.65.27A136.3,136.3,0,0,1,786.31,1327.19Zm265.33,45.33-3.31-.12-20-.13a175.44,175.44,0,0,0,4.69-23.15,191.33,191.33,0,0,0,1.58-21.68l25.49-.19A136.21,136.21,0,0,1,1051.64,1372.52Zm8.36-52.68-.81,0-24.67-.14a189.84,189.84,0,0,0-1.53-19,175.32,175.32,0,0,0-4.87-23.79c-.2-.7-.43-1.38-.64-2.07l22.34-.19.47-.47A136,136,0,0,1,1060,1319.84Zm-225.72,50.59a174,174,0,0,1-5.94-43l26.87.17,25.74,0c.1,15.61.85,30.3,2.29,44.3l-48.45.15C834.62,1371.58,834.44,1371,834.28,1370.43Zm1.29-95.54,25.07.17,23.25,0a409.65,409.65,0,0,0-2.9,44.31l-52.6.14a172.83,172.83,0,0,1,5.87-40.19C834.67,1277.86,835.12,1276.37,835.57,1274.89Zm63.67,139.2c-1.37-5.56-2.56-10.17-3.66-16.56q-1.46-8.37-2.52-17.31H923.2l29.4-.24c-.74,6.14-1.6,11.76-2.61,17.56-1.1,6.35-2.31,11.54-3.7,17.13a60,60,0,0,1-2.38,7.55H901.76A56.89,56.89,0,0,1,899.24,1414.09ZM892.16,1372c-.34-3.45-.66-7-.93-10.57-.83-10.91-1.26-22.24-1.32-33.7l33.29.06,32.42-.08c0,11.65-.43,23.17-1.25,34.29-.26,3.4-.55,6.71-.87,10l-30.29-.06Zm62.46-83c.6,9.43.93,19.44,1,30.43l-32.41-.06-33.28.09c.11-10.49.56-20.88,1.4-30.93.37-4.6.83-9,1.33-13.33l30.54.06,30.32-.08C953.94,1279.59,954.32,1284.16,954.62,1288.93Zm-41.32-87a29,29,0,0,1,5.31-6.09,13.91,13.91,0,0,1,3-1.93,7.69,7.69,0,0,1,2.94-.73h.21a7.07,7.07,0,0,1,2.71.56,11.2,11.2,0,0,1,2.9,1.81,25.47,25.47,0,0,1,5.1,6.1,57.54,57.54,0,0,1,4,7.61c.68,1.53,1.34,3.16,2,4.9l-18.24,0-16.38.08A71.18,71.18,0,0,1,913.3,1202Zm34.15,32.9c1.26,5.6,2.35,11.43,3.34,17.83.71,4.59,1.32,9.29,1.87,14.09l-29.45-.06-29.48.09c.68-4.92,1.44-9.74,2.32-14.44,1.18-6.28,2.47-12.07,4-17.68,1.16-4.38,2.38-8.37,3.66-12.13l19.53.06,21.06,0C945.38,1226.36,946.44,1230.41,947.45,1234.85Zm-74.78-20.46a93.46,93.46,0,0,1,11.73-9,83.23,83.23,0,0,1,20.33-9.44c1.31-.4,2.65-.73,4-1.06-.63.78-1.25,1.61-1.89,2.51a85.9,85.9,0,0,0-8.73,16.81Zm66.81-20.57a75.78,75.78,0,0,1,9.34,2.2,83.28,83.28,0,0,1,20.33,9.46,94.86,94.86,0,0,1,11.61,8.87l-13.13-.1q-7.82-.06-15.64-.06h-2c-1.08-3-2.17-5.71-3.31-8.21a66.5,66.5,0,0,0-4.66-8.61A41.18,41.18,0,0,0,939.48,1193.82Zm44.09,239.08a106.65,106.65,0,0,1-14.48,11.44,83.71,83.71,0,0,1-20.3,9.35,75.33,75.33,0,0,1-10.4,2.42c.67-.84,1.33-1.72,2-2.7a84.44,84.44,0,0,0,8.57-17.33,9.41,9.41,0,0,0,1.16-3.18Zm-62.4,23.95a8.51,8.51,0,0,1-1.36-.48,12.86,12.86,0,0,1-2.88-1.9,27.9,27.9,0,0,1-5.13-6.11,78.35,78.35,0,0,1-7.37-15.46h36.8s-.07.14-.11.23a74.81,74.81,0,0,1-7.56,15.63,26.25,26.25,0,0,1-5.19,6,11.65,11.65,0,0,1-2.87,1.77,7,7,0,0,1-1.63.44C923,1456.91,922.07,1456.92,921.17,1456.85ZM905.68,1454c-.31-.09-.61-.14-.91-.23a83.84,83.84,0,0,1-20.33-9.38,107.12,107.12,0,0,1-14.54-11.46h25.62c.31,0,.62,1.74.94,2.62a87.2,87.2,0,0,0,8.43,17.32Zm-67.47-187a141.39,141.39,0,0,1,14.55-29.38,121,121,0,0,1,11.82-15.24l14.19.12,16.29,0c-1.06,3.14-2.07,6.44-3,10-1.6,5.77-3,11.74-4.29,18.24q-1.54,7.92-2.73,16.08Zm150.65-44.65a122.35,122.35,0,0,1,11.87,15.32,142.18,142.18,0,0,1,14.51,29.37l-29.47-.19-24.4,0c-.65-5.29-1.37-10.44-2.2-15.46-1.1-6.59-2.29-12.6-3.66-18.36-.88-3.71-1.79-7.15-2.76-10.42,5,0,9.93,0,14.89-.06Zm29,52.6c.46,1.48.9,3,1.32,4.48a171.25,171.25,0,0,1,4.45,22.54c.75,5.79,1.21,11.71,1.4,17.66l-33.83-.19-26.37-.05c-.06-4.43-.19-8.69-.32-12.47-.24-6.25-.58-12.5-1-18.57-.34-4.57-.74-8.94-1.18-13.25l54.74-.15Zm.76,97.28-32.85-.21-23.35,0c.31-3,.6-6.12.86-9.27.93-11.37,1.44-23.14,1.55-35l60.24-.16a179.63,179.63,0,0,1-1.46,20.36,170.58,170.58,0,0,1-4.46,22.54C1019,1371,1018.79,1371.6,1018.62,1372.21Zm-2.48,7.28a138.28,138.28,0,0,1-15.47,31.43c-2.91,4.44-6.06,9.15-9.39,11.29H952.72c.63,0,1.24-3.13,1.84-5.45,1.47-5.76,2.77-10.54,4-17.1,1.14-6.28,2.11-12.73,2.94-19.41Zm-153.95,42.72c-3.33-2.14-6.48-7-9.38-11.44a135.38,135.38,0,0,1-15.53-31.1l23.36-.24h23.55c.8,6.42,1.73,12.52,2.83,18.67,1.18,6.56,2.46,12.31,3.92,18.09.64,2.53,1.31,3.88,2,6Zm-75.8-102.35a135.87,135.87,0,0,1,9.55-45.28l2.17.05,28.11.19c-.21.71-.44,1.41-.64,2.13a182.2,182.2,0,0,0-6.4,42.65Zm56-105.28a136.35,136.35,0,0,1,52.48-23.49,93.05,93.05,0,0,0-14.79,7.51,108.77,108.77,0,0,0-19,15.36c-.16.16-.3.33-.46.49l-12.12.06Zm126.92-18.43a136.67,136.67,0,0,1,34.59,18.4l-6.19-.07-4.68,0c-.17-.17-.33-.36-.5-.53a108.59,108.59,0,0,0-19.06-15.34C972.12,1197.71,970.73,1196.93,969.33,1196.15Zm38.28,236.69a136.73,136.73,0,0,1-39,21.42c1.67-.92,3.33-1.86,5-2.89A107.65,107.65,0,0,0,992.61,1436c1-1,2-1,3-3.13h11.91S1007.59,1432.84,1007.61,1432.84Zm-111.83,26.47a137.06,137.06,0,0,1-57-26.41H858c1,2.14,2,2.07,3,3.08a107.79,107.79,0,0,0,19,15.32A94.06,94.06,0,0,0,895.78,1459.31ZM833.16,1222l1.23,0c4.88.08,9.83.13,14.77.19l4.4,0c-2.77,3.36-5.42,6.89-7.9,10.59A151.86,151.86,0,0,0,828.75,1267l-29.66.26A137.53,137.53,0,0,1,833.16,1222Zm214.11,45.2-22.3-.14a151.94,151.94,0,0,0-17-34.27c-2.49-3.7-5.14-7.22-7.91-10.57,4,0,8-.08,12-.15l1.21,0A137.71,137.71,0,0,1,1047.27,1267.22ZM1011.48,1429a10.87,10.87,0,0,0,.12-1.52c0-2.24-1.82-5.28-4.06-5.28h-5c1.9-2.14,3.76-3.75,5.52-6.37a144.11,144.11,0,0,0,17.91-35.81l22.72-.19A135.38,135.38,0,0,1,1011.48,1429ZM797.7,1379l.41.47,29.63-.1a148.55,148.55,0,0,0,17.86,36.38,54.73,54.73,0,0,0,5.56,6.43H829.92c-.18,0-.36,1.24-.53,1.27A135.6,135.6,0,0,1,797.7,1379Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-54",
    d: "M107.86,1203H437.33A45.62,45.62,0,0,0,483,1157.42V827.08A45.63,45.63,0,0,0,441,781.6L90,753.19A45.63,45.63,0,0,0,40.76,801.4l21.56,358.76A45.62,45.62,0,0,0,107.86,1203Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M446.62,889.28a16.41,16.41,0,0,0-12.26-7.54L173.82,853.05l-5.11-19.62c-1.82-7-8.18-12.32-15.83-13.32l-49.34-6.39c-10.83-1.41-19.78,5.09-20.66,14.42s6.43,17.36,17,18.63l36.61,4.39,54.6,210a17,17,0,0,0,16.57,12.45l192.9-4.19a15.8,15.8,0,0,0,15.63-15.57,15.15,15.15,0,0,0-15.53-15.81h0l-178.3,2L213,1003.35l192.21,4.78h0A16.86,16.86,0,0,0,421,995.9l27.58-92.51A17.31,17.31,0,0,0,446.62,889.28ZM207.69,1064.83v-8.76h0ZM404.28,990.5l-200.08-5L178.91,874.08l238.32,25.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M239.71,1076.56c-18.15.55-34.23,15.53-35.44,33.51s13.13,31.8,31.57,30.45c18-1.32,33.08-16.53,34-33.84S257.43,1076,239.71,1076.56Zm-2.83,46.74c-8.51.53-15.08-5.84-14.55-14.17s7.91-15.32,16.36-15.67,14.71,6,14.24,14.1S245.3,1122.79,236.88,1123.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M368.77,1072.67c-15.11.46-28.18,14.06-28.83,30.4s11.51,29,26.83,27.87c15-1.1,27.28-14.89,27.74-30.68S383.55,1072.23,368.77,1072.67Zm-1.46,42.6c-7.08.43-12.66-5.39-12.38-13s6.28-13.93,13.31-14.22,12.38,5.49,12.14,12.91S374.31,1114.84,367.31,1115.27Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-17",
    x: 437.43,
    y: 2469.13,
    width: 28.33,
    height: 306.36,
    transform: "translate(903.2 5244.62) rotate(180)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M327.54,2763H575.66a0,0,0,0,1,0,0v15.4a3,3,0,0,1-3,3h-242a3,3,0,0,1-3-3V2763A0,0,0,0,1,327.54,2763Z",
    transform: "translate(903.2 5544.36) rotate(180)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M321.18,2400.49h251A30.47,30.47,0,0,1,602.68,2431v27.55A30.47,30.47,0,0,1,572.21,2489h-251a30.47,30.47,0,0,1-30.47-30.47V2431A30.46,30.46,0,0,1,321.18,2400.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-58",
    d: "M660.74,2264.86s42.09,6.53,89.42,38.17a23.59,23.59,0,0,1,10.41,22.54c-5.67,44.9-29,190.19-105.8,332.11a35.65,35.65,0,0,0-3.43,24.51l13.35,62.12,24.75,23.22H625.68l-42.46-114.9,18.16-5.74a34.34,34.34,0,0,0,24-32.16l2.13-123.25c-1.81-54.91,33.67-92.8,33.67-92.8l-101.83-4.95Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M714.34,2778.73c5.81,7.6-62.5,17.63-97,1,0,0-47.84-83.24-47.84-126.09,0,0,3.79-8.74,31.89-6.76,0,0,16.06,98.56,33,109.6s47.45,1.11,47.45,1.11S705.77,2767.52,714.34,2778.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-59",
    d: "M572.21,2400.49c.54-.94,109.64-13.12,109.64-13.12s-3.57,33.17,7.59,78.84,171.34,243.5,171.34,243.5L845.3,2763c51.93,18.09,97.51,16.48,147.77,4.72l-99.89-58s-97.42-332-157.09-391.19l-109.36-37.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-54",
    d: "M327.54,2207.33s-62.86,93.49-68,136.14,18.14,74.14,83.18,62.83c214.72-1.55,265.7,80.17,280.14,183.35a3.29,3.29,0,0,0,3.14,2.85,460.91,460.91,0,0,0,218.54-47.05,6.39,6.39,0,0,0,2.84-8.62c-104.72-205-25-245.51-250.35-306.27C566.69,2226.91,327.54,2207.33,327.54,2207.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M850.33,2745s-18.08,17.51-5.86,37c0,0,143.24,25.39,182.13,13.87,0,0-9.8-18.76-53.59-39.74l5,2.81a5.23,5.23,0,0,1-3.45,9.38C945.65,2766.71,885.93,2761.42,850.33,2745Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-60",
    d: "M497.53,2195s73.2-69.7,109.23-115.86a98,98,0,0,0,16.59-88.16c-16.45-55.42-45.69-112.82-48.35-121.75-4.09-13.7-86.17-13.13-86.17-13.13s-187.26,85.27-225,282.38l71.27,22.18s42.17-70.74,83.83-115.72c0,0-72.09,95.24-74.63,134.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-61",
    d: "M603.63,1819.17c-1.58,2.52-41,65.36-43,66.34s-46.34-8.64-63.06-28.33l54.89-63.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-62",
    d: "M609.08,1666s33,26,43.59,86.81-15.15,80.54-39.87,77.44-60.16-13.35-88.26-58.47S565.7,1634.07,609.08,1666Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-63",
    d: "M646.65,2200.12l-53.78-51.83-74.39,31.43s-74.06,11.47-116.44,0l-42.39-11.48-95.78-29.81-15,42.51a25.6,25.6,0,0,0,9.35,29.41c8.29,5.88,18,12.36,24.19,15.06,12.62,5.52,310.93-3.81,310.93-3.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M443.13,2224.56l.72,0,312-.34a14,14,0,0,0,0-27.93l-312,.34a14,14,0,0,0-.69,27.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M1036.26,1941.32H776.45a49.51,49.51,0,0,0-44.78,28.39L611.56,2224.4H934.43a30.1,30.1,0,0,0,28-19l93.14-235.67A20.75,20.75,0,0,0,1036.26,1941.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-64",
    d: "M853.22,2071.9c-5.63,17.49-1.47,34.48,9.29,37.94s24-7.91,29.68-25.4,1.47-34.48-9.29-37.94S858.85,2054.41,853.22,2071.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M1248.6,2839.18a11.11,11.11,0,0,0,4.51-.95,11.79,11.79,0,0,0,6-15.36L1019.49,2253a11.33,11.33,0,0,0-15-6.12,11.8,11.8,0,0,0-6,15.36l239.6,569.88A11.43,11.43,0,0,0,1248.6,2839.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M978.68,2839.18a11.41,11.41,0,0,0,10.5-7.07l239.6-569.88a11.79,11.79,0,0,0-6-15.36,11.34,11.34,0,0,0-15,6.12l-239.6,569.88a11.8,11.8,0,0,0,6,15.36A11.18,11.18,0,0,0,978.68,2839.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M305.09,2839.18a11.18,11.18,0,0,0,4.51-.95,11.8,11.8,0,0,0,6-15.36L76,2253a11.33,11.33,0,0,0-15-6.12,11.79,11.79,0,0,0-6,15.36l239.6,569.88A11.42,11.42,0,0,0,305.09,2839.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M35.17,2839.18a11.41,11.41,0,0,0,10.5-7.07l239.6-569.88a11.8,11.8,0,0,0-6-15.36,11.34,11.34,0,0,0-15,6.12L24.68,2822.87a11.8,11.8,0,0,0,6,15.36A11.11,11.11,0,0,0,35.17,2839.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M7.1,2236a11.52,11.52,0,0,1,2.71-10,13.24,13.24,0,0,1,9.93-4.39H1321.57a15.08,15.08,0,0,1,12.48,6.4,13.15,13.15,0,0,1,1,13.31l-14.11,28.62a19.86,19.86,0,0,1-17.93,10.75H28.68c-7.17,0-13.33-4.76-14.69-11.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M498.85,1685.64c30.21-15.2,51.83-65.67,36.51-92.13-39.71-68.57-139.48,8.16-92.36,73.33,7.33,10.14,17.38,18.81,29.46,22.06C481.52,1691.34,490.51,1689.83,498.85,1685.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M662.36,1696a14.82,14.82,0,0,1-21.85,13c-9.93-5.34-22.36-11.11-33.77-13.76-77.06-17.9-60.91,39.74-63.08,47.66-4.44,16.2-13.61-12.79-16-7.58-5.23,11.34,9.46,53.83,9.46,53.83s-61.35-27.59-70.69-55.69,10.83-80.07,26.32-96.46c14.72-15.58,65.28-30.68,87.18-24.79C601.09,1618,662.29,1634.27,662.36,1696Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-65",
    d: "M547.47,1756.57S544.36,1712.06,521,1723s5.16,41.74,16.73,52.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-66",
    d: "M2247.24,2578.9c30,2.59,82,6.81,123.06,8.61,24.67,1.09,38.86-1.33,47-4.6,0,.92,0,1.79-.07,2.6a8.49,8.49,0,0,1-8.07,8,1443,1443,0,0,1-161.14.17,6,6,0,0,1-4.92-9.08A49.14,49.14,0,0,1,2247.24,2578.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M2370.3,2587.51c-41-1.8-93.08-6-123.06-8.61,29.48-36.17,123.06-60.55,123.06-60.55h26.43c18.18,26.2,20.81,51.15,20.61,64.56C2409.16,2586.18,2395,2588.6,2370.3,2587.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-67",
    d: "M2401.18,2475.2l-2.47,48.94a11.19,11.19,0,0,1-9.55,10.52,43.49,43.49,0,0,1-19.85-1.65,13.22,13.22,0,0,1-8.89-10.16l-8.55-47.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M2707.94,2635.36c13-2.34,18.89-11.07,21.35-20.41a2.38,2.38,0,0,1,.05.26,23.25,23.25,0,0,1-11.39,24.9c-10.72,5.87-22.43,6.87-31.53,6.38a29.19,29.19,0,0,1-23.65-14.09l-.07-.13C2672.5,2638.54,2686.25,2639.27,2707.94,2635.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M2646.62,2490.28h21.8c33.2-.88,54,89.63,60.87,124.67-2.46,9.34-8.35,18.07-21.35,20.41-21.69,3.91-35.44,3.18-45.24-3.09-17.94-30.51-26.83-75.18-31.1-101.26C2626.73,2501.36,2646.62,2490.28,2646.62,2490.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-68",
    d: "M2665.62,2444.85l12.1,48.14a13.06,13.06,0,0,1-6.8,14.81c-6.77,3.47-16.3,7.12-25.06,6.07a10.92,10.92,0,0,1-8.9-7.28l-17.77-50.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-54",
    d: "M2239.85,1810.84s108.16,676.1,106.38,679.81c0,0,29.88,13.58,62.44,1.73,0,0-9.78-361.42-32.7-500,0,0,184.6,323,243.22,484,0,0,30.57-3.65,55.88-20.31,0,0-198.76-581.45-251.78-658.9Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-69",
    points: "2368.61 1987.58 2329.01 1924.32 2300.78 1918.64 2302.19 1911.6 2333.46 1917.89 2374.7 1983.76 2368.61 1987.58"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-70",
    d: "M1743.51,1148.79s73,16.1,117.38,36.6a40.54,40.54,0,0,1,19.85,20c13.28,29.08,53,102,130,136.81-11.09,14.72-29,45.35-36.74,96.83-46.26-34.43-86.21-91.94-105.38-186.26,0,0-14.61,7.94-32.82-.91a334.36,334.36,0,0,1-29.08-16.52,38.13,38.13,0,0,1-16.91-22.7c-3.17-12.46-1.3-23.41-1.3-35.16L1751,1165.82S1739.74,1161.56,1743.51,1148.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-71",
    d: "M1974,1439c7.79-51.48,25.65-82.11,36.74-96.83,47.86,21.62,110.1,28.53,189.37,1.07a83.81,83.81,0,0,1,22.66-4.47c42.2-2.48,181.26-7,296.32,31a89.4,89.4,0,0,1,53.94,49.1c31.13,71.44,81.52,234.11-58.37,316.24a346.35,346.35,0,0,0-33.77-63.89c22.53-38,29.2-89.91-10.77-157.5-29.16,78.72-42.83,193.58-45.69,244.41A109.22,109.22,0,0,0,2433,1807l.72,1.68a5.79,5.79,0,0,1-4.07,7.9c-78.76,17.69-160.67,12.89-185.14,10.87a10.11,10.11,0,0,1-9-7.71c-38.3-161.38-38.39-271.45-29-341C2170.69,1486.74,2061.14,1503.83,1974,1439Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-72",
    d: "M2219.75,1461.79a1.76,1.76,0,0,1-.49-.16c-2-.91-2.8-5.09-1.81-9.32,16.08-68.86,30.21-97.48,30.81-98.66,1.73-3.47,4.26-4.15,5.65-1.54s1.11,7.51-.61,11c-.22.44-13.52,27.74-28.65,92.54C2223.74,1459.51,2221.63,1462.1,2219.75,1461.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-73",
    d: "M2400.72,1244.75s8,84.24,15,109.16a8.52,8.52,0,0,1-4,9.73c-11.9,6.81-40.46,17.9-79.52-1.24a17.73,17.73,0,0,1-9.84-16.68l3.45-81.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-74",
    d: "M2324.06,1137s-25.49,58.54-27.2,89.27-8.33,50.66,27.2,56.85,65.45-11.52,81.67-42.12c0,0,25.4-47.16,19.7-66.48S2324.06,1137,2324.06,1137Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M2393.59,1219l-2-.89a4.88,4.88,0,0,1-2.38-6.7c5-9.68,14.78-31.86,2.16-37-16.26-6.67-80.67-19.81-94.56-42.66-13.36-22-1.52-50.32,16.26-58.38a2.45,2.45,0,0,1,3.2,1l1.49,2.81a2.41,2.41,0,0,0,4.45-.46h0a2.4,2.4,0,0,1,4.35-.62c4.27,6.84,15.8,17.92,46.64,23.61,43.83,8.09,72.8,25.83,73.53,56.11a2.41,2.41,0,0,0,3.73,2c3.24-2,8.42-2.9,15.34,2.92,12,10.12,7.11,36.37-19.28,58a2.4,2.4,0,0,0,.12,3.87c4.78,3.11,11.91,10.52-6.57,20.4-19.11,10.21-33.38,9.37-38.88,8.47a2.42,2.42,0,0,1-1.95-2.9l5.87-26.62a2.42,2.42,0,0,0-2.36-2.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-75",
    d: "M2392.48,1224.59s9.72-37.39,26.49-26.91-8.7,41.9-22.18,43.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-76",
    d: "M1847.82,1242c-.27-.33-26.5-32.53-35.29-37.49-4.8-2.71-7.51-5.65-8.29-9-.65-2.75,0-5.6,2.15-8.72l.65-1,33.46,6.71,17.29,14.83-2.29,2.67-16.59-14.24-30.21-6a6.76,6.76,0,0,0-1,5c.54,2.28,2.77,4.54,6.61,6.71,9.37,5.29,35.19,37,36.28,38.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-77",
    d: "M2393.2,1792.65l-115-2.5s100.28-28.35,106.51-20.63c0,0,62.15-40.84,96.21-98.29a346.35,346.35,0,0,1,33.77,63.89C2484.15,1753.05,2444.05,1784.19,2393.2,1792.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-78",
    d: "M2396.44,1772.74s2.37,45.82-57.77,39.16c-32.69-3.61-85.46-34.09-85.46-34.09S2390.76,1777.45,2396.44,1772.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M2372.89,1785l-.66,0-285.93-.31a12.67,12.67,0,1,1,0-25.33l285.93.31a12.66,12.66,0,0,1,.63,25.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M1829.27,1528.17h238.12a45.42,45.42,0,0,1,41.05,25.75l110.08,231H1922.6a27.57,27.57,0,0,1-25.65-17.26l-85.37-213.72A18.84,18.84,0,0,1,1829.27,1528.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M1997,1646.59c5.16,15.86,1.35,31.27-8.52,34.41s-22-7.17-27.2-23-1.35-31.27,8.52-34.41S1991.87,1630.73,1997,1646.59Z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBankingImg2);
export default __webpack_public_path__ + "static/media/banking_img_2.904e7a883a9be30ef20e6285a23640f6.svg";
export { ForwardRef as ReactComponent };